export const componentList = [
  {
    name: "基础设施",
    component: "Infrastructure",
    size: {
      width: 420,
      height: 250,
    },
  },
  {
    name: "环境设备",
    component: "RoomEnvironmentDevice",
    size: {
      width: 580,
      height: 400,
    },
  },
  {
    name: "动力设备",
    component: "PowerDevice",
    size: {
      width: 480,
      height: 400,
    },
  },
  {
    name: "UPS-动力设备",
    component: "UPSPowerDevice",
    size: {
      width: 480,
      height: 400,
    },
  },
  {
    name: "告警分布",
    component: "AlarmDistribution",
    size: {
      width: 370,
      height: 195,
    },
  },
  {
    name: "告警趋势",
    component: "AlarmTrend",
    size: {
      width: 370,
      height: 220,
    },
  },
  {
    name: "告警信息",
    component: "AlarmInfo",
    size: {
      width: 370,
      height: 445,
    },
  },
  {
    name: "安防,消防设备",
    component: "SecurityDevice",
    size: {
      width: 388,
      height: 400,
    },
  },
  {
    name: "空间情况",
    component: "RoomSituation",
    size: {
      width: 1050,
      height: 470,
    },
  },
  {
    name: "Pue实时值",
    component: "Pue",
    size: {
      width: 420,
      height: 250,
    },
  },
  {
    name: "Wue实时值",
    component: "Wue",
    size: {
      width: 420,
      height: 250,
    },
  },
  {
    name: "Pue趋势图",
    component: "TrendPue",
    size: {
      width: 580,
      height: 400,
    },
  },
  {
    name: "Wue趋势图",
    component: "TrendWue",
    size: {
      width: 580,
      height: 400,
    },
  },
  {
    name: "电子地图",
    component: "Map",
    size: {
      width: 420,
      height: 200,
    },
  },
  {
    name: "全景图",
    component: "IndoorSetting",
    size: {
      width: 1280,
      height: 768,
    },
  },
  {
    name: "机房设备功率列表",
    component: "PowerofITEquipmentRoom",
    size: {
      width: 410,
      height: 880,
    },
  },
  {
    name: "空间设备统计",
    component: "PowerStatistics",
    size: {
      width: 1050,
      height: 470,
    },
  },
  {
    name: "PUE状态",
    component: "RealValuePue",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "WUE状态",
    component: "RealValueWue",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "机房温湿度",
    component: "controlRoomHumiture",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "暖通设备参数轮显",
    component: "warmDeviceRealTimeParameter",
    size: {
      width: 410,
      height: 400,
    },
  },
  {
    name: "安防,消防设备(门磁)",
    component: "SecurityOtherDevice",
    size: {
      width: 388,
      height: 400,
    },
  },
  {
    name: "楼层导航",
    component: "floor",
    size: {
      width: 1060,
      height: 850,
    },
  },
  {
    name: "子系统监测",
    component: "Subsystem",
    size: {
      width: 380,
      height: 240,
    },
  },
  {
    name: "能耗监测",
    component: "EnergyConsump",
    size: {
      width: 380,
      height: 280,
    },
  },
  {
    name: "能耗趋势",
    component: "EnergyConsumpTrend",
    size: {
      width: 380,
      height: 280,
    },
  },
  {
    name: "精密配电柜",
    component: "PDUowerDevice",
    size: {
      width: 480,
      height: 400,
    },
  },
  {
    name: "UPS",
    component: "UPSThreePhaseVoltage",
    size: {
      width: 480,
      height: 400,
    },
  },
  {
    name: "配电柜电表",
    component: "CabinetElectricity",
    size: {
      width: 480,
      height: 400,
    },
  },
  {
    name: "机房温湿度柱状图",
    component: "controlRoomHumitureBar",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "UPS设备",
    component: "controlRoomUPSBar",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "温湿度传感器设备",
    component: "controlRoomHumitureDeviceBar",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "精密空调设备",
    component: "controlRoomAirConditionerBar",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "列头柜",
    component: "controlRoomCabinetBar",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "漏水设备",
    component: "controlRoomWaterLeak",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "避雷设备",
    component: "controlRoomLightning",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "蓄电池",
    component: "controlRoomBattery",
    size: {
      width: 522,
      height: 400,
    },
  },
  {
    name: "加湿机",
    component: "controlRoomHumidifier",
    size: {
      width: 522,
      height: 400,
    },
  },
];
